
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import Info from 'components/common/Info';

import infoActions from 'actions/infoActions';
import * as Models from 'models/api';

import * as studentInfo from 'utils/campaign/studentInfo'

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  const user = appState.session.user!
  const uiType = appState.ui.type
  let studentUser: Models.StudentUser | null = null
  if (uiType === 'student') {
    studentUser = user as Models.StudentUser
  }

  const isAvailableStudentInfo = studentUser && studentInfo.isAvailable(studentUser)

  return {
    isAvailableStudentInfo,
    info: appState.info,
    ...ownProps,
    user,
    studentUser,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {
  return {
    ...stateProps,
    fetchData: (id: number) => {
      dispatch(infoActions.fetchDetailRecord({ id }))
    },
    getInfo: (id: number) => {
      const page = stateProps.info.detail
      if (id !== page.id) {
        return null
      }
      return page.record
    },
  }
}

export type mappedProps = ReturnType<typeof mergeProps>

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(Info))